import React from "react";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  CardSubtitle,
} from "reactstrap";
import Select from "react-select";
// Utils
import cellPhoneMask from "../../../../utils/helpers/masks/cellPhone";

export default function ModalActionControl({
  setNewActionForm,
  newActionForm,
  trySaveAction,
  whatsappTemplates,
  guestGroups,
  eventSchedules,
  closeModalActionControl,
  whatsappTagsForm,
  setWhatsappTagsForm,
  attributesListLabel,
}) {
  const getTemplateWhatsapp = React.useCallback((templateId = '') => {
    let _template = whatsappTemplates.find(t => { return t.value === templateId });
    return _template;
  }, [whatsappTemplates]);

  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <CardSubtitle>
          {newActionForm.id ? 'Editar' : 'Nova'} Ação
        </CardSubtitle>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Tipo de Ação *`}
          </Label>
          <Input
            className="form-control"
            type="select"
            value={newActionForm.type}
            onChange={(e) => setNewActionForm({ ...newActionForm, type: e.target.value })}
          >
            <option value="">Selecione</option>
            <option value="whatsapp">Whatsapp</option>
            <option value="whatsappOrganizer">Whatsapp Organizador</option>
          </Input>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Descrição *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={newActionForm.description}
            onChange={(e) => setNewActionForm({ ...newActionForm, description: e.target.value })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Programação *`}
          </Label>
          <Input
            className="form-control"
            type="select"
            value={newActionForm.scheduleId}
            onChange={(e) => setNewActionForm({ ...newActionForm, scheduleId: e.target.value })}
          >
            <option value="">Selecione</option>
            {eventSchedules.map(s => (
              <option value={s.value}>{s.text}</option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Grupo`}
          </Label>
          <Input
            className="form-control"
            type="select"
            value={newActionForm.groupId}
            onChange={(e) => setNewActionForm({ ...newActionForm, groupId: e.target.value })}
          >
            {guestGroups.map(g => (
              <option value={g.value}>{g.text}</option>
            ))}
          </Input>
        </Col>
      </Row>
      {newActionForm.type === 'whatsapp' || newActionForm.type === 'whatsappOrganizer' ? (
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Número de Envio Servidor`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={newActionForm.serverNumber}
              onChange={(e) => setNewActionForm({ ...newActionForm, serverNumber: e.target.value })}
            >
              <option value=''>Selecione</option>
              <option value='1'>1</option>
              <option value='2'>2</option>
            </Input>
          </Col>
        </Row>
      ) : null}
      {newActionForm.type === 'whatsappOrganizer' ? renderWhatsappOrganizerFields() : null}
      {newActionForm.type === 'whatsapp' ? renderWhatsappFields() : null}
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
            <div style={{ padding: 3 }}>
              <Button
                color="danger"
                onClick={() => closeModalActionControl()}
              >
                Cancelar
              </Button>
            </div>
            <div style={{ padding: 3 }}>
              <Button
                color="success"
                onClick={() => trySaveAction(newActionForm)}
              >
                Salvar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )

  function renderWhatsappFields() {
    let _template;
    if (newActionForm.templateId) {
      _template = getTemplateWhatsapp(newActionForm.templateId);
    }

    return (
      <>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">
              {`Template *`}
            </Label>
            <Select
              placeholder="Selecione"
              noOptionsMessage={() => "Nenhum template encontrado"}
              options={whatsappTemplates.map(g => ({ value: g.value, label: g.text }))}
              value={whatsappTemplates
                .filter(g => g.value === newActionForm.templateId)
                .map(g => ({ value: g.value, label: g.text }))[0] || null}
              onChange={(selected) => setNewActionForm({ ...newActionForm, templateId: selected ? selected.value : '' })}
              isClearable
            />
          </Col>
        </Row>
        {newActionForm.templateId !== '' && (
          <>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={12}>
                <Label htmlFor="formFile" className="form-label">
                  {`Mensagem *`}
                </Label>
                <spam>
                  {_template.message}
                </spam>
              </Col>
            </Row>
            {_template.numberOfTags > 0 && renderTagField(0, 'tag1')}
            {_template.numberOfTags > 1 && renderTagField(1, 'tag2')}
            {_template.numberOfTags > 2 && renderTagField(2, 'tag3')}
            {_template.numberOfTags > 3 && renderTagField(3, 'tag4')}
            {_template.numberOfTags > 4 && renderTagField(4, 'tag5')}
            {_template.numberOfTags > 5 && renderTagField(5, 'tag6')}
            {_template.numberOfTags > 6 && renderTagField(6, 'tag7')}
            {_template.numberOfTags > 7 && renderTagField(7, 'tag8')}
            {_template.numberOfTags > 8 && renderTagField(8, 'tag9')}
            {_template.numberOfTags > 9 && renderTagField(9, 'tag10')}
            {_template.hasUrl && (
              <Row style={{ marginBottom: 10 }}>
                <Col lg={12}>
                  <Label htmlFor="formFile" className="form-label">
                    {`Url ${_template.urlType === 'DOCUMENT' ? 'Documento' : _template.urlType === 'VIDEO' ? 'Vídeo' : 'Imagem'} *`}
                  </Label>
                  <Input
                    className="form-control"
                    type="text"
                    value={newActionForm.url}
                    onChange={(e) => setNewActionForm({ ...newActionForm, url: e.target.value })}
                  />
                </Col>
              </Row>
            )}
          </>
        )}
      </>
    )

    function renderTagField(index, key) {
      return (
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Tag${index + 1} *`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={whatsappTagsForm[key]}
              onChange={(e) => setWhatsappTagsForm({ ...whatsappTagsForm, [key]: e.target.value })}
            >
              {attributesListLabel.map(a => (
                <option value={a.value}>{a.text}</option>
              ))}
            </Input>
          </Col>
        </Row>
      )
    }
  }

  function renderWhatsappOrganizerFields() {
    return (
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="formFile" className="form-label">
            {`Telefone Organizador *`}
          </Label>
          <Input
            className="form-control"
            type="text"
            value={newActionForm.organizerCellPhone}
            onChange={(e) => setNewActionForm({ ...newActionForm, organizerCellPhone: cellPhoneMask(e.target.value) })}
          />
        </Col>
      </Row>
    )
  }
}
